import {useQuery} from '@apollo/client';
import {useEffect, useState} from 'react';
import {BCP_CHECK_JOBS} from '../graphql/queries/bcpCheckJobQueries';
import {CheckJobFilterType, CheckJobListResponse, CheckJobType} from '../graphql/types/BcpCheckJobTypes';

export interface BcpCheckJobListQueryResult {
    data: CheckJobType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
}

export const useBcpCheckJobListQuery = (
    filters: CheckJobFilterType,
    currentPage: number,
    pageSize: number,
    enabled: boolean = true,
): BcpCheckJobListQueryResult => {
    const [listData, setListData] = useState<CheckJobType[]>([]);
    const [total, setTotal] = useState(0);

    const buildVariables = () => ({
        filters: {
            id: filters.id ?? undefined,
            name: filters.name || undefined,
            userGroupId: filters.userGroupId ?? undefined,
            status: filters.status !== undefined && filters.status !== null ? filters.status : undefined,
            createUser: filters.createUser || undefined,
        },
        pageRequest: {
            page: currentPage,
            size: pageSize,
            sortBy: 'id',
            sortDirection: 'DESC',
        },
    });

    const {data, loading, refetch} = useQuery<CheckJobListResponse>(BCP_CHECK_JOBS, {
        variables: buildVariables(),
        skip: !enabled,
        fetchPolicy: 'cache-and-network',
    });

    useEffect(() => {
        const content = data?.bcpCheckJobs?.content;
        if (content) {
            setListData(content);
        }
        const rawTotal = data?.bcpCheckJobs?.pageInfo?.totalElements;
        if (rawTotal !== undefined && rawTotal !== null) {
            const n = Number(rawTotal);
            if (Number.isFinite(n)) {
                setTotal(Math.max(0, Math.trunc(n)));
            }
        }
    }, [data]);

    return {
        data: listData,
        loading,
        refetch,
        totalElements: total,
    };
};
